// store/store.ts
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import expireReducer from "redux-persist-expire";

import userReducer from "./feature/user/userSlices";
import aiCourseFinderReducer from "./feature/ai-course-finder/aiCourseFinderSlice";
import countryReducer from "./feature/country/countrySlice";
import universityReducer from "./feature/university/universitySlices";
import courseReducer from "./feature/courses/courseSlice";
import talkToExpertReducer from "./feature/talkToExpert/talkToExpertSlice";
import loaderReducer from "./feature/loader/loaderSlice";
import commonReducer from "./feature/common/commonSlice";
import chatReducer from "./feature/chatbot/chatBotSlice";
import panelNotificationReducer from "@/store/feature/notifications/notificationSlice"
import bookTestReducer from "./feature/bookExam/bookTestSlice";
import scholarshipReducer from "./feature/scholarship/scholarshipSlice";


const persistConfig = {
  key: "root",
  storage,
  blacklist: ["bookTest"],
  transforms: [
    expireReducer("userProfile", {
      expireSeconds: 3600,
      expiredState: {},
      autoExpire: true,
    }),
    expireReducer("chat", {
      expireSeconds: 3600,
      expiredState: { messages: [] },
      autoExpire: true,
    }),
    expireReducer("aiCourseFinder", {
      expireSeconds: 3600,
      expiredState: {},
      autoExpire: true,
    }),
  ],
};

const rootReducer = combineReducers({
  userProfile: userReducer,
  aiCourseFinder: aiCourseFinderReducer,
  country: countryReducer,
  university: universityReducer,
  course: courseReducer,
  talkToExpert: talkToExpertReducer,
  loader: loaderReducer,
  chat: chatReducer,
  common: commonReducer,
  panelNotification: panelNotificationReducer,
  bookTest: bookTestReducer,
  scholarship: scholarshipReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
